import React from 'react';
import { Helmet } from 'react-helmet';

import Hero from './Component/Hero'

const Home = () => {
    return (
        <div>
            <Helmet>
                <title data-react-helmet="true">The Bagdad Chase Mining Company</title>
                <meta data-react-helmet="true" name="description" content="" />
                <meta data-react-helmet="true" name="keywords" content="" />
                <meta data-react-helmet="true" property="og:title" content="" />
                <meta data-react-helmet="true" property="og:type" content="website" />
                <meta data-react-helmet="true" property="og:url" content="" />
                <meta data-react-helmet="true" property="og:image" content="" />
                <meta data-react-helmet="true" property="og:description" content="" />
            </Helmet>


            <Hero />


        </div>
    )
}

export default Home